import poppins400Woff2 from "@fontsource/poppins/files/poppins-latin-400-normal.woff2?url";
import poppins600Woff2 from "@fontsource/poppins/files/poppins-latin-600-normal.woff2?url";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { logger } from "./logger";
import { AdobeAnalytics } from "./tracking/adobeAnalytics";
import { loadDecibel } from "./tracking/decibel";
import { isMirageEnabled } from "./utils/importMeta";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/300-italic.css";
import "@fontsource/poppins/400-italic.css";
import "@fontsource/poppins/600-italic.css";
import "@fontsource/poppins/700-italic.css";

if (isMirageEnabled()) {
	logger.info("Using mock data for API requests!");
	await import("./api-client/server/server");
}

AdobeAnalytics.init();

loadDecibel();

const container = document.createElement("div");
document.body.append(container);

const root = createRoot(container);
root.render(
	<StrictMode>
		<link
			rel="preload"
			href={poppins400Woff2}
			as="font"
			type="font/woff2"
			crossOrigin="anonymous"
		/>
		<link
			rel="preload"
			href={poppins600Woff2}
			as="font"
			type="font/woff2"
			crossOrigin="anonymous"
		/>
		<App />
	</StrictMode>,
);
